<template>
  <div
    :class="{
      [$style.box]: true,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
  >
    <div v-for="input in form.inputs" :key="input.name" :class="$style.item">
      <BaseRadioBox
        @check="inputHandler"
        :input="input"
        :margin="false"
        :class="$style.radioBox"
      />

      <div
        :class="{
          [$style.options]: true,
          [$style.animation]: animationTrigger
        }"
      >
        <template
          v-if="input.options && input.options.length > 0 && input.showOptions"
        >
          <h2 :class="$style.headingOne">{{ input.optionHeading }}</h2>
          <h3 :class="$style.headingTwo">{{ input.optionHeading_2 }}</h3>
          <BaseRadioHorizontal
            v-for="option in input.options"
            :key="option.name"
            :option="option"
            @check="circleHandler"
            :class="$style.radioHorizontal"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BaseRadioBox from '@/components/ui/BaseRadioBox.vue'
import BaseRadioHorizontal from '@/components/ui/BaseRadioHorizontal.vue'
import store from '@/store'

export default {
  components: {
    BaseRadioBox,
    BaseRadioHorizontal
  },
  props: {
    form: {
      type: Object
    }
  },
  data() {
    return {
      animationTrigger: false,
      timeout: null
    }
  },
  computed: {
    el() {
      return store.state.el
    },
    showOptions1() {
      return this.form.inputs[0].showOptions
    },
    showOptions2() {
      return this.form.inputs[1].showOptions
    }
  },
  methods: {
    inputHandler(data) {
      this.$emit('check', data)
    },
    circleHandler(data) {
      this.$emit('check', data)
    }
  },
  watch: {
    showOptions1(val) {
      this.animationTrigger = false

      this.timeout = setTimeout(() => {
        this.animationTrigger = true
      }, 300)
    },
    showOptions2(val) {
      this.animationTrigger = false

      this.timeout = setTimeout(() => {
        this.animationTrigger = true
      }, 300)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="scss" module>
.box {
  display: flex;
  justify-content: center;
}

.radioBox {
  margin: 10px;
}

.headingOne {
  margin-top: 21px;
  font-size: 22px;
  font-weight: bold;
  line-height: 1.2;
}
.headingTwo {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.2;
}

.options {
  // opacity: 0.3;
  line-height: 1.2;
}

.animation {
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}

// note: LAND
.land {
  .radioBox {
    height: 160px;
    width: 160px;
    margin: 10px;
  }
  .options {
    width: 170px;
    .headingOne,
    .headingTwo {
      width: 170px;
    }
  }
}

// note: PHONE
.phone {
  &.box {
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    .radioBox {
      width: 100%;
      height: 66px;
      max-height: 100%;
      min-height: 50px;
      padding: 10px 20px;
      margin-right: 0px;
      margin-left: 0px;
      margin: 0px;
      margin-bottom: 10px;
      font-size: 16px;
      .label {
        padding: 0 15px;
        flex: 0 0 90%;
        font-size: 14px;
        text-align: left;
        font-weight: bold;
      }
      .icon {
        width: 40px;
        height: 40px;
        margin-bottom: 0;
        object-fit: contain;
      }
      .checkedIcon {
        // z-index: 100;
        position: absolute;
        width: 30px;
        height: 30px;
        right: 30px;
        top: 32px;
      }
    }
    .options {
      width: 100%;
      .headingOne,
      .headingTwo {
        text-align: left;
        width: 100%;
      }
      .headingTwo {
        margin-bottom: 23px;
      }
      .radioHorizontal:last-child {
        margin-bottom: 37px;
      }
    }
  }
}
</style>
